module.exports = __webpack_public_path__ + "static/bellbanking3.95a97f25.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/bellbanking3.jpeg
// module id = 1253
// module chunks = 35783957827783